import { mapActions } from 'vuex'

export const BillingPortal = {
  methods: {
    ...mapActions('billingPortal', ['requestBillingPortal']),

    async manageBilling() {
      this.$posthog.capture('manage_billing_link_click')

      try {
        // Send the portal back to the page the customer launched it from
        // (e.g. /plans/solo?discount=...) rather than the Dashboard default.
        // Include the query string so page state that depends on it (like the
        // discount consumed in IsUpgrading's created()) survives the round-trip.
        const response = await this.requestBillingPortal(window.location.pathname + window.location.search)

        if ('url' in response) {
          this.$posthog.capture('manage_billing_end')
          window.location.href = response.url
        }
      } catch (error) {
        this.$posthog.capture('manage_billing_fail')
        console.error(error)
      }
    }
  }
}
